module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train_color_red-89affb3efc219ad7333b422cbf6d1482.svg";